import { faArrowDownLong } from "@fortawesome/free-solid-svg-icons";
import "./experties.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion, inView, animate } from "framer-motion";
import { useRef } from "react";
import { Reveal } from "../Reveal";

export default function Expertise() {
  const container = useRef(null);

  inView(container, ({ target }) => {
    animate(target, { opacity: 1 });
  });

  const expertiseList = [
    {
      title: "Web Designing",
      range: 85,
      technologies: "Figma",
      platform: "",
    },
    {
      title: "Web Development",
      range: 95,
      technologies: "NextJS/MERN Stack",
      platform: "Front-end/Back-end",
    },
    {
      title: "Application Dev.",
      range: 70,
      technologies: "Flutter",
      platform: "Android",
    },
    {
      title: "Software Automation",
      range: 95,
      technologies: "NodeJS",
      platform: "Web/Data Scraping",
    },
    {
      title: "Bot Development",
      range: 95,
      technologies: "NodeJS",
      platform: "Telegram",
    },
  ];
  return (
    <div className="container mt-5 position-relative">
      <Reveal widthClass="w-fit" revealSecondDiv={true}>
        <h1 id="expertise" className="about-heading">
          Expertise
        </h1>
      </Reveal>

      <div className="centerText position-absolute"> Expertise</div>
      <div className="row mt-2 justify-content-center">
        {expertiseList.map((item, index) => (
          <div key={index} className="col-lg-4 col-md-6 col-sm-9 mt-3">
            <motion.div
              key={index}
              initial={{
                opacity: 0,
                x: -20,
              }}
              transition={{
                duration: 0.3,
                delay: index * 0.1,
              }}
              viewport={{ once: true, amount: 0.5 }}
              whileInView={{ opacity: 1, x: 0 }}
            >
              <div className="card text-white expertiese-card text-left">
                <div className="card-body">
                  <h4 className="card-title">{`${item.range.toString()}%`}</h4>
                  <input
                    type="range"
                    readOnly
                    value={item.range}
                    min="0"
                    max="100"
                  />
                  <p className="card-title pt-1">{item.title}</p>
                  <div className="d-flex position-relative">
                    <p className="text-uppercase technology-text font-neue">
                      {item.technologies}
                    </p>
                    <p className="text-right technology-text position-absolute top-1 end-0">
                      {item.platform}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        ))}
      </div>
      <div className="my-100">
        {" "}
        <a href="#projects" className="text-white">
          {" "}
          <FontAwesomeIcon icon={faArrowDownLong} size="xl" />{" "}
        </a>
      </div>
    </div>
  );
}
